import React from "react";
import type { ComponentProps, PartData } from "@enonic/react-components";

import Calendar from "/react4xp/components/shared/frontend/assets/calendar.svg";
import Location from "/react4xp/components/shared/frontend/assets/location.svg";
import Stopwatch from "/react4xp/components/shared/frontend/assets/stopwatch.svg";
import {
  formatDatePeriod,
  formatDate,
} from "/react4xp/components/shared/lib/Utils";
import type { EventDetailsPartProps } from "./EventDetails.d";

export const EventDetailsPart = (props: ComponentProps<PartData>) => {
  const {
    from,
    to,
    location,
    registrationDateTime,
    registrationInfo,
    registrationButtonUrl,
    registrationButtonText,
    organizers,
  } = (props.data as EventDetailsPartProps) ?? {};

  return (
    <header className="container">
      <div className="event-details factbox">
        <h2 className="visually-hidden">Arrangement detaljer</h2>
        <div>
          <h3 className="text-h-medium">
            <Calendar />
            Tid
          </h3>
          {from && (
            <time
              dangerouslySetInnerHTML={{
                __html: formatDatePeriod(from, to),
              }}
            />
          )}
        </div>
        <div>
          <h3 className="text-h-medium">
            <Location />
            Sted
          </h3>
          {location && <address>{location}</address>}
        </div>
        {registrationDateTime && (
          <div>
            <h3 className="text-h-medium">
              <Stopwatch />
              Påmeldingsfrist
            </h3>
            {registrationDateTime && (
              <p>
                <time>{formatDate(registrationDateTime)}</time>
              </p>
            )}
            {registrationInfo && <p>{registrationInfo}</p>}

            {registrationButtonUrl && (
              <a href={registrationButtonUrl} className="btn btn--primary">
                {registrationButtonText}
              </a>
            )}
          </div>
        )}
      </div>
      {organizers && (
        <div className="event-organizer">Arrangør: {organizers}</div>
      )}
    </header>
  );
};

export default EventDetailsPart;
